import api from './api';

export const referentiels = {
  // Responsables
  // page (optionnel) : filtre aux responsables ayant accès à cette page via permissions_pages
  getResponsables: (page) => api.get('/referentiels/responsables', { params: page ? { page } : {} }),
  createResponsable: (data) => api.post('/referentiels/responsables', data),
  updateResponsable: (id, data) => api.put(`/referentiels/responsables/${id}`, data),
  deleteResponsable: (id) => api.delete(`/referentiels/responsables/${id}`),

  // Marques
  getMarques: () => api.get('/referentiels/marques'),
  getMarquesAll: () => api.get('/referentiels/marques/all'), // admin : inclut les concessions[] liées
  createMarque: (data) => api.post('/referentiels/marques', data),
  updateMarque: (id, data) => api.put(`/referentiels/marques/${id}`, data),
  deleteMarque: (id) => api.delete(`/referentiels/marques/${id}`),

  // Modèles
  getModeles: (marque_id) => api.get('/referentiels/modeles', { params: { marque_id } }),
  createModele: (data) => api.post('/referentiels/modeles', data),
  updateModele: (id, data) => api.put(`/referentiels/modeles/${id}`, data),
  deleteModele: (id) => api.delete(`/referentiels/modeles/${id}`),

  // Actions parking
  getActionsParking:   ()        => api.get('/referentiels/actions-parking'),
  createActionParking: (data)    => api.post('/referentiels/actions-parking', data),
  updateActionParking: (id, data) => api.put(`/referentiels/actions-parking/${id}`, data),
  deleteActionParking: (id)      => api.delete(`/referentiels/actions-parking/${id}`),

  // Statuts Atelier
  getStatutsAtelier:    ()         => api.get('/referentiels/statuts-atelier'),
  createStatutAtelier:  (data)     => api.post('/referentiels/statuts-atelier', data),
  updateStatutAtelier:  (id, data) => api.put(`/referentiels/statuts-atelier/${id}`, data),
  deleteStatutAtelier:  (id)       => api.delete(`/referentiels/statuts-atelier/${id}`),

  // Types de Travaux
  getTravauxTypes:      ()         => api.get('/referentiels/travaux-types'),
  createTravauxType:    (data)     => api.post('/referentiels/travaux-types', data),
  updateTravauxType:    (id, data) => api.put(`/referentiels/travaux-types/${id}`, data),
  deleteTravauxType:    (id)       => api.delete(`/referentiels/travaux-types/${id}`),

  // Sources Mapping
  getSourcesMapping:      ()         => api.get('/referentiels/sources-mapping'),
  createSourceMapping:    (data)     => api.post('/referentiels/sources-mapping', data),
  updateSourceMapping:    (id, data) => api.put(`/referentiels/sources-mapping/${id}`, data),
  deleteSourceMapping:    (id)       => api.delete(`/referentiels/sources-mapping/${id}`),

  // Statuts Leads Web
  // params : { service?: 'VN'|'VO'|'ATELIER'|'PIECES'|'AUTRE', actif?: '1' }
  getStatutsLeadsWeb:   (params = {})  => api.get('/referentiels/statuts-leads-web', { params }),
  createStatutLeadsWeb: (data)         => api.post('/referentiels/statuts-leads-web', data),
  updateStatutLeadsWeb: (id, data)     => api.put(`/referentiels/statuts-leads-web/${id}`, data),
  deleteStatutLeadsWeb: (id)           => api.delete(`/referentiels/statuts-leads-web/${id}`),

  // Statuts OR en cours
  getStatutsOrEnCours:    ()         => api.get('/referentiels/statuts-or-en-cours'),
  createStatutOrEnCours:  (data)     => api.post('/referentiels/statuts-or-en-cours', data),
  updateStatutOrEnCours:  (id, data) => api.put(`/referentiels/statuts-or-en-cours/${id}`, data),
  deleteStatutOrEnCours:  (id)       => api.delete(`/referentiels/statuts-or-en-cours/${id}`),

  // Flottes courtoisie (référentiel par concession)
  getFlottesCourtoisie:    ()         => api.get('/referentiels/flottes-courtoisie'),
  createFlotteCourtoisie:  (data)     => api.post('/referentiels/flottes-courtoisie', data),
  updateFlotteCourtoisie:  (id, data) => api.put(`/referentiels/flottes-courtoisie/${id}`, data),
  deleteFlotteCourtoisie:  (id)       => api.delete(`/referentiels/flottes-courtoisie/${id}`),

};

export default referentiels;